module.exports = __webpack_public_path__ + "04_glasses_black.cb306586.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer4/04_glasses_black.png
// module id = LTbd
// module chunks = 0